import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormFieldComponent } from '../base-form-field.component';

@Component({
  standalone: false,
  selector: 'ideapa-otp-field',
  template: `
    <ideapa-form-field-wrapper
      [label]="label"
      [shouldShowError]="shouldShowError"
      [errors]="errors"
      [tooltip]="tooltip"
      [showHint]="showHint"
    >
      <ideapa-otp-input
        [hasError]="shouldShowError"
        [formControl]="formControl"
        (blur)="onBlur()"
      >
      </ideapa-otp-input>
    </ideapa-form-field-wrapper>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OtpFieldComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtpFieldComponent extends BaseFormFieldComponent {
  @Input()
  showHint = true;

  @Input()
  forceUppercase = false;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  blur = new EventEmitter();

  onBlur() {
    this.blur.emit();
  }
}
